import { render } from "./Index.vue?vue&type=template&id=b8434a1a"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/AssetEvents/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b8434a1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b8434a1a', __exports__)) {
    console.log('reload')
    api.reload('b8434a1a', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=b8434a1a", () => {
    console.log('re-render')
    api.rerender('b8434a1a', render)
  })

}


export default __exports__